import { useId } from 'react';
import PropTypes from 'prop-types';
import styles from './navigation.module.scss';
import Menu from './helpers/Menu';
import AccordionWrapper from '../../accordion/accordionWrapper';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

export default function Navigation({ navigation = [] }) {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;
  const idPrefix = useId();

  if (!navigation?.length) return null;

  if (isMobile) {
    return (
      <div className={styles.navigation} data-testid="footer-navigation-list">
        {navigation
          .flatMap((column) => column)
          .filter((menu) => menu?.title && !menu?.description)
          .map((menu) => (
            <div
              key={menu.title}
              data-testid={`footer-navigation-accordion-${menu.title}`}
            >
              <AccordionWrapper
                id={`${idPrefix}-${menu.title}`}
                head={
                  <span className={styles.accordionHead}>{menu.title}</span>
                }
                body={<Menu column={[menu]} hideTitles />}
                containerStyle={styles.accordionContainer}
              />
            </div>
          ))}
      </div>
    );
  }

  return (
    <div className={styles.navigation} data-testid="footer-navigation-list">
      {navigation.map((column, index) => {
        const columnKey =
          column.find((menu) => menu?.title)?.title ??
          column.map((menu) => menu?.title || '').join('|');
        return (
          <div
            key={columnKey}
            className={styles.column}
            data-testid={`footer-navigation-column-${index}`}
          >
            <Menu column={column} />
          </div>
        );
      })}
    </div>
  );
}

Navigation.propTypes = {
  navigation: PropTypes.array,
};
